var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOpensession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #062860;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.72,14.52c-6.5-6.38-14.09-9.51-22.88-9.51H37.28c-8.91,0-16.5,3.13-22.76,9.51-6.26,6.26-9.51,13.85-9.51,22.64v227.01l78.88-78.88-39.98-.24v-35.29h100.8v100.8h-35.28l-.36-40.1-82.62,82.73c3.37,1.2,6.99,1.81,10.84,1.81h225.56c8.79,0,16.38-3.13,22.88-9.39,6.26-6.26,9.27-13.97,9.27-22.88V37.16c0-8.79-3.01-16.38-9.27-22.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpensession);
export default __webpack_public_path__ + "static/media/icon_opensession.e28195dc2b9a3e40f01e1f64b1d17a0d.svg";
export { ForwardRef as ReactComponent };